<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
        <div class="form-wrapper">
          <Dialog
            :title="$t('certificates.replace_certificate')"
            :visible.sync="showModal"
            width="40%"
            custom-class="min-width-dialog"
            center>
            <span :key="t"  v-for="t in processMessage" class="text-center w-full inline-block word-break-n">{{ t }}</span>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
                <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')" @click="save" :loading="loading" />
              </div>
            </template>
          </Dialog>
          <Dialog
            :title="$t('certificates.check_data')"
            :visible.sync="showModalCheckData"
            width="40%"
            custom-class="min-width-dialog"
            center>
            <span :key="t"  v-for="t in processMessageCheckData" class=" w-full inline-block word-break-n">{{ t }}</span>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
                <base-button class="w-full" @click="showModalCheckData = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="subirCertificado" :loading="loading" />
              </div>
            </template>
          </Dialog>
          <Dialog
            :title="$t('certificates.delete_old_certificate')"
            :visible.sync="showModalDelete"
            width="40%"
            custom-class="min-width-dialog"
            @close="hideAndGoBack"
            center>
            <span class="text-center w-full inline-block word-break-n">{{ processMessageDelete }}</span>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
                <base-button class="w-full" @click="showModalDelete = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')"  @click="deleteCertificate" :loading="loading" />
              </div>
            </template>
          </Dialog>
          <el-form
            :model="form"
            :rules="rules"
            ref="ruleForm"
            class="flex flex-row w-full"
          >
          <div class="flex-1">
          <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{$t('certificates.group_old_cert')}}</h3>
             <div class="mb-6">
              <div  class="lg:mb-2">
                <base-ro-input :label="$t('app.name')" :data="form.oldCommonName"/>
              </div>
              <div class="lg:mb-2">
                    <base-ro-input :label="$t('app.serial_number')" :data="form.oldSerialNumber"/>
                  </div>
              <!-- <div class="lg:mb-2">
                <div class="mandatory">
                  <base-ro-input :label="$t('certificates.expires_at')" :data="form.FechaCaducidad"/>
                </div>
              </div> -->
            </div>

          <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{$t('certificates.new_certificate')}}</h3>
            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('certificates.type_extend')}}</label>
              <el-form-item prop="type">
                <base-el-select :options="tiposCertificado" class="w-full" v-model="form.type" @change="onChangeType" />
              </el-form-item>
            </div>

            <div v-if="form.type === 'pfx'" >
               <div class="lg:mb-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('users.password')}}</label>
                    <el-form-item prop="password">
                      <el-input
                        clearable
                        v-model="form.password"
                        maxlength='255'
                      />
                    </el-form-item>
                <div class="flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2  mb-2 lg:mb-0">
                    <base-obligatory-icon/>
                    <el-form-item prop="file" ref="uploadpfxref">
                      <Upload
                        ref="upload"
                        accept=".pfx"
                        id="pfxselector"
                        class="bg-white dark:bg-darkblue-900 dark:bg-darkblue "
                        :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                        drag
                        action="#"
                        :show-file-list="false"
                        :multiple="false"
                        :auto-upload=false
                        :on-remove="handleRemove"
                        :on-change="handleChange">
                        <i class="el-icon-upload"></i>
                        <p v-if="file.name" class="el-upload__text"><em>{{file.name}}</em></p>
                        <div v-else class="el-upload__text" v-html="$tc('app.upload_default_no_file_text', 1)"></div>
                      </Upload>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>

            <div class="lg:mb-2" v-if="form.type === 'srl'">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.serial_number')}}</label>
              <el-form-item prop="SerialNumber">
                <el-input
                  clearable
                  v-model="form.SerialNumber"
                  maxlength='100'
                />
              </el-form-item>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.name')}}</label>
              <el-form-item prop="CommonName">
                <el-input
                  clearable
                  v-model="form.CommonName"
                  maxlength='50'
                />
              </el-form-item>
            </div>

            <div class="lg:mb-2" v-if="form.type === 'usr'">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('users.entity_name')}}</label>
              <el-form-item prop="user">
                <el-input
                  clearable
                  v-model="form.user"
                  maxlength='50'
                />
              </el-form-item>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('users.password')}}</label>
              <el-form-item prop="pass">
                <el-input
                  clearable
                  v-model="form.pass"
                  maxlength='50'
                />
              </el-form-item>
            </div>

            <div class="lg:mb-2" v-if="(form.type === 'srl' || form.type === 'usr')">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('certificates.expires_at')}}</label>
              <el-form-item prop="FechaCaducidad">
                <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                  v-model="form.FechaCaducidad" type="date" :picker-options="dateRangeOptions"
                  :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
          </el-form>
        </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.cancel')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive mode="primary" :text="$t('app.save')" icon="check" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { getCertificate } from '@/services/certificates/getCertificate'
import { getPfxData } from '@/services/certificates/getPfxData'

import { Upload, Dialog } from 'element-ui'

import { replaceCertificate } from '@/services/certificates/replaceCertificate'

import moment from 'moment'
import { i18n } from '@/i18n'
import { deleteCertificate } from '@/services/certificates/deleteCertificate'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'

export default {
  /* eslint-disable camelcase */
  name: 'template-detail',
  components: {
    Upload,
    Dialog,
    DetailLayout
    // DetailLayoutFullWidth
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      loading: false,
      searchView: false,
      activeName: 'es',
      header: {
        title: i18n.t('certificates.replace_header'),
        icon: 'certificates',
        breadcrumb: {},
        nav: [],
        url: 'certificates'
      },
      file: {
        name: '',
        b64: ''
      },
      selectedCifs: [],
      showModal: false,
      showModalCheckData: false,
      checkDataSerialNumber: '',
      checkDataCommonName: '',
      checkDataExpirationDate: '',
      form: {
        oldCommonName: '',
        oldSerialNumber: '',

        type: 'pfx',
        CommonName: '',
        SerialNumber: '',
        FechaCaducidad: '',
        file: '',
        password: '',
        clienteId: null,
        user: '',
        pass: '',
        id: 0
      },
      showModalDelete: false,
      processMessageDelete: i18n.t('certificates.delete_overrided_confirmation'),
      rules: {
        clienteId: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        password: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        SerialNumber: [
          { validator: this.isSerialNumberValid, trigger: 'blur' }
        ],
        CommonName: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        user: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        pass: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        FechaCaducidad: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        file: [
          {
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.file.name) {
                callback(new Error(i18n.t('validation.complete')))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.not_single_valid_extension', { ext: '.pfx' }),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.file.name || this.file.name.length < 5 || this.file.name.substr(this.file.name.length - 4).toUpperCase() !== '.PFX') {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: '.pfx' })))
              } else {
                callback()
              }
            }
          }
        ]
      }
    }
  },
  computed: {
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    idCliente: function () {
      return this.$route.params.idCliente
    },
    serial: function () {
      return this.$route.params.serial
    },
    tipoCertificado: function () {
      return this.$route.params.tipoCertificado
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    processMessage: function () {
      const message = []
      let nombreCert = ''
      if (this.form.type === 'pfx') nombreCert = this.file.name
      else if (this.form.type === 'srl') nombreCert = i18n.t('certificates.with_serial', { serial: this.form.SerialNumber })
      else if (this.form.type === 'usr') nombreCert = i18n.t('certificates.with_username', { username: this.form.user })
      const nombreCertOld = i18n.t('certificates.with_serial', { serial: this.serial })
      message.push(i18n.t('certificates.replace_certificate_confirmation', { nombreCert, nombreCertOld }))

      return message
    },
    processMessageCheckData: function () {
      const message = []
      const nombreCertOld = i18n.t('certificates.with_serial', { serial: this.serial })
      message.push(i18n.t('certificates.check_data_replace_confirmation', { nombreCertOld }))
      message.push('')
      message.push(`${i18n.t('app.serial_number')}: ${this.checkDataSerialNumber}`)
      message.push(`${i18n.t('app.name')}: ${this.checkDataCommonName}`)
      message.push(`${i18n.t('certificates.expires_at')}: ${moment(this.checkDataExpirationDate).format('DD-MM-yyyy HH:mm')}`)

      return message
    },
    tiposCertificado: function () {
      return this.$store.getters['config/TIPOS_CERT']
    },
  },
  created: async function () {
    const idCliente = this.idCliente
    const serial = this.serial
    const tipoCert = this.tipoCertificado
    const breadcrumbs = []
    await this.downloadData(idCliente, serial, tipoCert)
    if (this.$route.params.noticeType !== undefined && this.$route.params.noticeType !== null && this.$route.params.noticeType !== '') {
      if (this.$route.params.noticeType === 'certificadoscaducar') {
        this.header.url = 'notices/certificadoscaducar'
        breadcrumbs.push({ path: 'notices/certificadoscaducar', name: i18n.t('avisos.noticesCertsCaduc') })
      } else {
        this.header.url = 'notices/certificadoscaducados'
        breadcrumbs.push({ path: 'notices/certificadoscaducados', name: i18n.t('avisos.noticesCertsCaducados') })
      }
    } else {
      breadcrumbs.push({ path: 'certificates', name: i18n.t('certificates.header') })
    }
    breadcrumbs.push({ path: '', name: this.form.oldCommonName })
    this.$store.commit('app/setheaderBreadCrumb', this.form.oldCommonName)
    
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    isSerialNumberValid: function (rule, value, callback) {
      const re = /["<>|:*?\\/]/
      const minLen = 5
      if (!value) {
        return callback(new Error(i18n.t('validation.complete')))
      } else if (re.test(value)) {
        return callback(new Error(i18n.t('validation.codigo_ext.chars')))
      } else if (value.length < minLen) {
        return callback(new Error(i18n.t('validation.length_min') + i18n.tc('app.n_character', minLen)))
      } else {
        callback()
      }
    },
    onChangeType: function (value) {
    },
    submitForm: function (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.form.type === 'pfx') this.uploadPFX()
          else this.showModal = true
        } else {
          this.$message({
            type: 'error',
            message: i18n.t('feedback.error.process_data_error')
          })
          return false
        }
      })
    },
    goBack: function () {
      this.$router.push({ name: 'certificates' })
    },
    hideAndGoBack () {
      this.showModalDelete = false
      this.goBack()
    },
    downloadData: async function (idCliente, serial, tipoCertificado) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = { idCliente, serial, tipoCertificado }
        const data = await getCertificate(params)
        if (data.blnError === true) {
          this.doFeedback(`${data.msgError} [${data.codError}]`)
        } else {
          this.setCertificate(data.Certificado)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setCertificate: function (certificate) {
      this.form.oldSerialNumber = certificate.SerialNumber
      this.form.oldCommonName = certificate.CommonName
      // this.form.oldtype = certificate.TipoCertificado
      // this.form.oldFechaCaducidad = moment(certificate.FechaCaducidad).format('DD-MM-yyyy HH:mm')
      // this.form.oldclienteId = certificate.idCliente
    },
    handleChange: function (file) {
      this.$refs.uploadpfxref.clearValidate()
      this.file.name = file.name
      this.getBase64(file.raw).then(res => {
        const b64 = res.split(',')
        this.file.b64 = b64[1]
      })
    },
    handleRemove: function () {
      this.file.name = null
      this.file.b64 = null
    },
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        let res = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          res = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(res)
        }
      })
    },
    save: async function () {
      try {
        this.loading = true
        await this.uploadPFX()
        this.showModal = false
      } catch (error) {
        this.doFeedback()
      } finally {
        this.loading = false
      }
    },
    getIDOldCert () {
      const data = {
        SerialNumber: this.serial,
        TipoCertificado: this.tipoCertificado,
        idCliente: this.idCliente,
      }
      return data
    },
    deleteCertificate: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const data = this.getIDOldCert()
        const payload = []
        payload.push(data)
        const response = await deleteCertificate(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.showModalDelete = false
      }
    },
    uploadPFX: async function () {
      if (this.form.type === 'pfx') {
        const payload = {
          Base64PFX: this.file.b64,
          PasswordPFX: this.form.password,
          idCliente: 0,
        }
        const responseGetData = await getPfxData(payload)
        if (responseGetData.blnError === false) {
          this.checkDataSerialNumber = responseGetData.datosCertificado.SerialNumber
          this.checkDataCommonName = responseGetData.datosCertificado.CommonName 
          this.checkDataExpirationDate = responseGetData.datosCertificado.ExpirationDate
          this.showModalCheckData = true
        } else {
          this.doFeedback(`${responseGetData.msgError} [${responseGetData.codError}]`)
        }
      } else {
        this.subirCertificado()
      }
    },
    subirCertificado: async function () {
      this.showModalCheckData = false
      this.$store.commit('app/setLoading', true)
      const data = this.getIDOldCert()
      if (this.form.type === 'pfx') {
        data.nuevoCertificado = {
          Base64PFX: this.file.b64,
          pwd: this.form.password,
          TipoCertificado: 'pfx',
        }
      } else if (this.form.type === 'srl') {
        data.nuevoCertificado = {
          SerialNumber: this.form.SerialNumber,
          CommonName: this.form.CommonName,
          FechaCaducidad: this.form.FechaCaducidad,
          TipoCertificado: 'srl',
        }
      } else if (this.form.type === 'usr') {
        data.nuevoCertificado = {
          Usuario: this.form.user,
          Password: this.form.pass,
          FechaCaducidad: this.form.FechaCaducidad,
          TipoCertificado: 'usr',
        }
      }
      const response = await replaceCertificate(data)

      if (response.blnError === false) {
        this.doFeedback(i18n.t('feedback.success.certificate_replaced_msg'), 'success')
        this.showModalDelete = true
      } else {
        this.doFeedback(`${response.msgError} [${response.codError}]`)
      }
      if (this.form.type === 'pfx') this.$refs.upload.clearFiles()
      this.file = {
        name: null,
        b64: null
      }
      this.resetForm()
      this.form.CommonName = ''
      this.form.SerialNumber = ''
      this.form.FechaCaducidad = ''
      this.form.file = ''
      this.form.password = ''
      this.form.clienteId = null
      this.form.user = ''
      this.form.pass = ''
      this.form.id = 0
      this.$store.commit('app/setLoading', false)
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    selectionChange: function (selectedData) {
      this.selectedCifs = selectedData
    },
    handleSelect: function (item) {
      this.selectedCifs = []
      this.selectedCifs.push(item)
    }
  }

}
</script>

<style scoped>

.el-upload-dragger {
    background-color: #fff;
    border: 1px
    dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
  max-heigth: 100%;
}

.file-selected {
  color: rgb(90, 90, 90);
  text-transform: uppercase;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

 .el-loading-parent--relative {
    position: relative !important; }

  .el-loading-parent--hidden {
    overflow: hidden !important; }

    div.el-loading-mask {
        background-color: rgba(6,13,46,.8);
    }

  .el-loading-mask {
    position: absolute;
    z-index: 2000;
    background-color: rgba(255, 255, 255, 0.9);
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s; }
    .el-loading-mask.is-fullscreen {
      position: fixed; }
      .el-loading-mask.is-fullscreen .el-loading-spinner {
        margin-top: -25px; }
        .el-loading-mask.is-fullscreen .el-loading-spinner .circular {
          height: 50px;
          width: 50px; }
    div.el-loading-mask .el-loading-spinner {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
body.el-loading-parent--relative {
    position: inherit !important;
}
  .el-loading-spinner {
    top: 50%;
    margin-top: -21px;
    width: 100%;
    text-align: center;
    position: absolute; }
    .el-loading-spinner .el-loading-text {
      color: #00BBFF;
      margin: 3px 0;
      font-size: 14px; }
    .el-loading-spinner .circular {
      height: 42px;
      width: 42px;
      -webkit-animation: loading-rotate 2s linear infinite;
      animation: loading-rotate 2s linear infinite; }
    .el-loading-spinner .path {
      -webkit-animation: loading-dash 1.5s ease-in-out infinite;
      animation: loading-dash 1.5s ease-in-out infinite;
      stroke-dasharray: 90, 150;
      stroke-dashoffset: 0;
      stroke-width: 2;
      stroke: #00BBFF;
      stroke-linecap: round; }
    .el-loading-spinner i {
      color: #00BBFF; }

  .el-loading-fade-enter,
  .el-loading-fade-leave-active {
    opacity: 0; }
</style>

<style lang="sass" scoped>
</style>
